export function onClickService(service) {
  this.setState({selectedService: service.object});
}
